import { Component, OnInit } from "@angular/core";
import { CardState, SplitBarTone } from "../../data-visualization";
import { ResolveReportService } from "../../../_services";
import { ResolveSourceBreakdownRow, ResolveSummaryResponse } from "../../../reports/models/reports";
import {
  ResolveBreakdownRow,
  ResolveCampaignRow,
  ResolveMomentRow,
  ResolveOutcomeRow,
  buildResolveBuyAgainStats,
  buildResolveCampaignsOriginated,
  buildResolveExternalLinksData,
  buildResolveExternalLinksLegend,
  buildResolveExternalLinksShare,
  buildResolveReceiptCard,
  buildResolveReceiptMatchedPercentage,
  buildResolveReceiptSplit,
  buildResolveRefundStats,
  buildResolveRequestOutcomes,
  buildResolveRequestSource,
  buildResolveSourceBreakdown,
  buildResolveTopIntents,
  buildResolveTopMoments,
  buildResolveTopProductsPurchased,
  buildResolveViewOrderStats,
  resolveAiInsights,
  resolveCampaignsNameColumn,
  resolveCampaignsValueColumns,
  resolveProductsNameColumn,
  resolveProductsValueColumns,
  resolveRequestOutcomesNameColumn,
  resolveRequestOutcomesValueColumns,
  resolveRequestSourceNameColumn,
  resolveRequestSourceValueColumns,
  resolveSectionIcons,
  resolveSourceBreakdownNameColumn,
  resolveSourceBreakdownValueColumns,
  resolveTopIntentsNameColumn,
  resolveTopIntentsValueColumns,
  resolveTopMomentsNameColumn,
  resolveTopMomentsValueColumns,
} from "../../resolve";

@Component({
  selector: "app-resolve-report",
  templateUrl: "./resolve-report.component.html",
  styleUrls: ["./../../dashboard-section-v2.scss", "./../dashboard-report.component.scss"],
})
export class DashboardResolveReportComponent implements OnInit {
  splitBarTone = SplitBarTone;
  icons = resolveSectionIcons;
  receiptCard = buildResolveReceiptCard(null);
  receiptMatchedPercentage = buildResolveReceiptMatchedPercentage(null);
  receiptSplit = buildResolveReceiptSplit(null);
  externalLinksData = buildResolveExternalLinksData(null);
  externalLinksLegend = buildResolveExternalLinksLegend(null);
  externalLinksShare = buildResolveExternalLinksShare(null);
  topMoments: CardState<ResolveMomentRow> = { data: [], loading: false, noData: true };
  topMomentsNameColumn = resolveTopMomentsNameColumn;
  topMomentsValueColumns = resolveTopMomentsValueColumns;

  viewOrderStats = buildResolveViewOrderStats(null);
  sourceBreakdown: CardState<ResolveBreakdownRow> = { data: [], loading: false, noData: true };
  sourceBreakdownNameColumn = resolveSourceBreakdownNameColumn;
  sourceBreakdownValueColumns = resolveSourceBreakdownValueColumns;
  topIntents: CardState<ResolveBreakdownRow> = { data: [], loading: false, noData: true };
  topIntentsNameColumn = resolveTopIntentsNameColumn;
  topIntentsValueColumns = resolveTopIntentsValueColumns;

  buyAgainStats = buildResolveBuyAgainStats(null);
  campaignsOriginated: CardState<ResolveCampaignRow> = { data: [], loading: false, noData: true };
  campaignsNameColumn = resolveCampaignsNameColumn;
  campaignsValueColumns = resolveCampaignsValueColumns;
  topProductsPurchased: CardState<ResolveCampaignRow> = { data: [], loading: false, noData: true };
  productsNameColumn = resolveProductsNameColumn;
  productsValueColumns = resolveProductsValueColumns;

  refundStats = buildResolveRefundStats(null);
  requestSource: CardState<ResolveBreakdownRow> = { data: [], loading: false, noData: true };
  requestSourceNameColumn = resolveRequestSourceNameColumn;
  requestSourceValueColumns = resolveRequestSourceValueColumns;
  requestOutcomes: CardState<ResolveOutcomeRow> = { data: [], loading: false, noData: true };
  requestOutcomesNameColumn = resolveRequestOutcomesNameColumn;
  requestOutcomesValueColumns = resolveRequestOutcomesValueColumns;

  aiInsights = resolveAiInsights;

  constructor(private resolveReportService: ResolveReportService) {}

  ngOnInit() {
    this.applySummary(this.resolveReportService.lastSummary);
  }

  private applySummary(response: ResolveSummaryResponse) {
    this.receiptCard = buildResolveReceiptCard(response);
    this.receiptMatchedPercentage = buildResolveReceiptMatchedPercentage(response);
    this.receiptSplit = buildResolveReceiptSplit(response);
    this.externalLinksData = buildResolveExternalLinksData(response);
    this.externalLinksLegend = buildResolveExternalLinksLegend(response);
    this.externalLinksShare = buildResolveExternalLinksShare(response);

    const topMoments = buildResolveTopMoments(response);
    this.topMoments = { data: topMoments, loading: false, noData: topMoments.length === 0 };

    this.viewOrderStats = buildResolveViewOrderStats(response);

    const sourceBreakdown = buildResolveSourceBreakdown(this.getSourceBreakdownRows(response));
    this.sourceBreakdown = { data: sourceBreakdown, loading: false, noData: sourceBreakdown.length === 0 };

    const topIntents = buildResolveTopIntents(response);
    this.topIntents = { data: topIntents, loading: false, noData: topIntents.length === 0 };

    this.buyAgainStats = buildResolveBuyAgainStats(response);

    const campaigns = buildResolveCampaignsOriginated(response);
    this.campaignsOriginated = { data: campaigns, loading: false, noData: campaigns.length === 0 };

    const products = buildResolveTopProductsPurchased(response);
    this.topProductsPurchased = { data: products, loading: false, noData: products.length === 0 };

    this.refundStats = buildResolveRefundStats(response);

    const sources = buildResolveRequestSource(response);
    this.requestSource = { data: sources, loading: false, noData: sources.length === 0 };

    const outcomes = buildResolveRequestOutcomes(response);
    this.requestOutcomes = { data: outcomes, loading: false, noData: outcomes.length === 0 };
  }

  private getSourceBreakdownRows(response: ResolveSummaryResponse): ResolveSourceBreakdownRow[] {
    let rows: ResolveSourceBreakdownRow[] = [];
    if (response && response.source_breakdown && response.source_breakdown.product) {
      rows = response.source_breakdown.product;
    }
    return rows;
  }
}
